import { Injectable, TemplateRef } from '@angular/core';
import { AbstractService } from '@sol/components';

export interface PrototypeTopbarServiceState {
  leadingBreadcrumbs: TemplateRef<void> | undefined;
}

/**
 * Lets a page put content at the start of the topbar trail, before the route's own breadcrumbs, the way
 * the platform's asm-topbar projects its scope switcher. TopbarService.setBreadcrumbs only reaches the end.
 */
@Injectable({
  providedIn: 'root',
})
export class PrototypeTopbarService extends AbstractService<PrototypeTopbarServiceState> {
  constructor() {
    super({ leadingBreadcrumbs: undefined });
  }

  public setLeadingBreadcrumbs(template: TemplateRef<void> | undefined): void {
    this.patch({ leadingBreadcrumbs: template });
  }
}
